export type ReactionType = "boa" | "legal" | "uau";

export interface ReactionOption {
	type: ReactionType;
	emoji: string;
	label: string;
}

const BOA: ReactionOption = { type: "boa", emoji: "👍", label: "Boa!" };
const LEGAL: ReactionOption = { type: "legal", emoji: "😎", label: "Legal!" };
const UAU: ReactionOption = { type: "uau", emoji: "😮", label: "Uau!" };

export const REACTION_OPTIONS: ReadonlyArray<ReactionOption> = [
	BOA,
	LEGAL,
	UAU,
];

export const DEFAULT_REACTION: ReactionType = "boa";

export function reactionOption(type: ReactionType): ReactionOption {
	return REACTION_OPTIONS.find((option) => option.type === type) ?? BOA;
}

export function toReactionType(value: unknown): ReactionType | null {
	return REACTION_OPTIONS.some((option) => option.type === value)
		? (value as ReactionType)
		: null;
}

export function toReactionTypes(values: unknown): ReactionType[] {
	if (!Array.isArray(values)) return [];
	return values.reduce<ReactionType[]>((acc, value) => {
		const type = toReactionType(value);
		if (type && !acc.includes(type)) acc.push(type);
		return acc;
	}, []);
}
